import PropTypes from 'prop-types'
import { Avatar, Typography } from '@mui/joy'

import { HBox } from '@/components/HBox'
import { VBox } from '@/components/VBox'

import i18n from '@/i18n'

export function AccountRow({ account }) {
    if (!account) {
        return <>Error</>
    }
    if (account.node.banner_url) {
        return (
            <VBox>
                <img 
                    src={account.node.icon_url || account.node.banner_url || account.node.logotype_url} 
                    alt={account.node.name}
                    style={{ width: '100pt' }} 
                />
                <Typography fontSize="sm" sx={{ opacity: 0.5 }} variant="caption">
                    {i18n.t(account.node.type)} · {i18n.t(account.node.role)}
                </Typography>
            </VBox>
        )
    }
    return (
        <HBox sx={{ alignItems: 'center', gap: '5pt' }}>
            {account.node.avatar_url && (
                <Avatar src={account.node.avatar_url} alt={account.node.name} />
            )}
            <VBox>
                <Typography fontWeight={500}>{account.node.name}</Typography>
                <Typography fontSize="sm" sx={{ opacity: 0.5 }} variant="caption">
                    {i18n.t(account.node.type)} · {i18n.t(account.node.role)}
                </Typography>
            </VBox>
        </HBox>
    )
}

AccountRow.propTypes = {
    account: PropTypes.shape({
        node: PropTypes.shape({
            name: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
            role: PropTypes.string.isRequired,
            icon_url: PropTypes.string,
            banner_url: PropTypes.string,
            logotype_url: PropTypes.string,
            avatar_url: PropTypes.string,
        }).isRequired,
    }).isRequired,
}